import styled from 'styled-components';

export const DivCellText = styled.div(
  ({
    $isName,
    $isStacked,
    $level = 0,
    $canWrite,
    $underlineEditable = true,
    $cornerSize = 6,
    $bg = '',
    $fg,
  }) => ({
    position: 'relative',
    backgroundColor: $bg,
    borderRadius: '3px',
    border: `0px solid var(--ds-border-base)`,
    color: $isName
      ? $isStacked
        ? $fg ?? '#303030ff'
        : 'var(--ds-text-title)'
      : $canWrite
      ? $fg ?? 'var(--ds-text-base)'
      : $fg ?? 'var(--ds-text-base)', // couleur neutre (les statuts ont déjà leurs couleurs)
    fontFamily: 'proxima-nova',
    fontSize: $isName ? ($isStacked ? `${16 - 1 * $level}px` : '13px') : '13px',
    fontWeight: $isStacked ? 800 - $level * 50 : $isName ? '600' : '500',
    overflow: 'hidden',
    paddingLeft: 5,
    textOverflow: 'ellipsis',
    width: '100%',
    height: '100%',
    minHeight: '22px',
    containerType: 'inline-size',
    containerName: 'cell',
    display: 'flex',
    alignItems: 'center',
    cursor: $canWrite ? 'text' : 'default',
    // option : soulignement discret si éditable
    textDecoration:
      !$isName && $canWrite && $underlineEditable
        ? 'underline dashed var(--ds-border-base) 1px'
        : 'none',
    textUnderlineOffset: $underlineEditable ? '3px' : undefined,

    // label dynamique (inchangé)
    '&::before': {
      content: 'attr(data-label)',
      display: 'none',
      color: '#888',
      fontSize: 12,
      marginRight: 4,
    },

    // Petit triangle en coin pour champs éditables
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 2,
      right: 0,
      width: 0,
      height: 0,
      borderTop: `${$cornerSize}px solid ${
        $canWrite ? 'var(--ds-edit-corner, #9aa1a6)' : 'transparent'
      }`,
      borderLeft: `${$cornerSize}px solid transparent`,
      opacity: $canWrite ? 1 : 0,
      pointerEvents: 'none',
      transition: 'border-top-color .15s ease, opacity .15s ease',
    },

    // Feedback hover très léger (sans voler les couleurs des statuts)
    '&:hover': $canWrite
      ? { backgroundColor: 'var(--ds-bg-hover, rgba(0,0,0,0.03))' }
      : {},

    '&:hover::after': {
      borderTopColor: $canWrite
        ? 'var(--ds-edit-corner-hover, #6b728033)'
        : 'transparent',
      opacity: $canWrite ? 1 : 0,
    },

    // Quand la largeur du container > 150px
    // '@container cell (min-width: 150px)': {
    //   '&::before': {
    //     display: !$isName && $isStacked ? 'inline' : 'none',
    //   },
    // },
  })
);

export const DataCellYesNoContainer = styled.div({
  width: '20px',
  height: '20px',
});

export const DataCellNumberContainer = styled.div({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  containerType: 'inline-size',
  containerName: 'cell',
  height: '100%',
  minWidth: '50px',
});

export const DataCellLabel = styled.div({
  display: 'none', // caché par défaut
  marginRight: 6,
  color: 'var(--ds-text-secondary)',
  fontSize: 12,
  fontWeight: 500,
  width: '100px',

  '@container cell (min-width: 150px)': {
    display: 'inline', // visible seulement si > 200px
  },
});

export const DataCellNumberValue = styled.div({
  color: (props) => (props.$fg ? props.$fg : 'var(--ds-text-base)'),
  backgroundColor: (props) => (props.$bg ? props.$bg : ''),
  fontFamily: 'proxima-nova',
  fontSize: 12,
  fontWeight: '500',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: (props) =>
    props.$isStacked ? 'calc(100% - 120px)' : 'calc(100% - 20px)',
  minWidth: (props) => (props.$isStacked ? '50px' : '50px'),
  maxWidth: (props) => (props.$isStacked ? '200px' : '100px'),
  paddingLeft: '5px',
});

export const DataCellCrumbtrailContainer = styled.div({
  height: 'auto',
  marginTop: '2px',
  paddingLeft: '4px',
  overflow: 'hidden',
  display: 'flex',
  flexWrap: 'wrap',
});

export const DataCellCrumbtrailItem = styled.div({
  fontSize: '11px',
  fontWeight: 600,
  color: 'var(--ds-text-title)',
  padding: '3px 3px 3px 3px',
  margin: '2px 4px 0px 4px',
  borderRadius: '3px',
  height: '22px',
  '&:hover': {
    fontWeight: 900,
  },
});

export const DataCellCrumbtrailSeparator = styled.div({
  color: 'red',
  fontWeight: 600,
  fontSize: '9px',
  color: 'var(--ds-text-title)',
  lineHeight: '22px',
  padding: '3px 3px 3px 3px',
  margin: '-3px 4px 0px 4px',
});
